import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { AppMainComponent } from '../../../../app.main.component';
import { OpportunityService } from '../../../../opportunities/opportunity.service';
import { CrmOpportunityFieldService } from './fields.service';
import { Answer } from '../../constants/constants';

@Component({
  selector: 'app-opportunity-fields',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.scss'],
  providers: [ConfirmationService]
})

export class CrmOpportunityFieldsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() addNewField: any;
  @Output() reLoadConfigurations = new EventEmitter();

  invalidData = false;
  addEditOppHeader;
  oppTypeId = 0;
  displayAddOppData = false;
  selectedOppDataType;
  isOppDataDisabled: boolean = false;

  oppSources = [];
  ratings = [];
  closeWonReasons = [];
  closeLostReasons = [];


  answertypeConstants = Answer;
  activeId: number;
  inactiveId: number;
  activeReason: Array<any> = [];
  inactiveReason: Array<any> = [];

  showValidation: boolean = false;
  lostId: number;
  wonId: number;

  oppDataTypes = [
    { id: 0, name: "Source", code: "opp source" },
    { id: 1, name: "Quality", code: "quality" },
    { id: 2, name: "Close Won", code: "closewon" },
    { id: 3, name: "Close Lost", code: "closelost" },
    { id: 4, name: "Active Reason", code: "ActivatedReason" },
    { id: 5, name: "Inactive Reason", code: "InactivatedReason" },
  ];

  oppDataTemp = {
    "id": 0,
    "createdSource": "",
    "updatedSource": "",
    "createdBy": this.app.user.userId,
    "updatedBy": 0,
    "createdDate": new Date().toISOString(),
    "updatedDate": new Date().toISOString(),
    "name": "",
    "description": "",
    "statusId": 0,
    "isActive": false,
    "isDefault": false,
    "organizationId": this.app.user.organizationId,
  };

  private ratingSubscription$ = new Subscription();
  constructor(
    private fb: FormBuilder, private app: AppMainComponent,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private appMainService: AppMainService,
    private fieldService: CrmOpportunityFieldService,
    private service: ConfigurationService,
    private opportunityService: OpportunityService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.addNewField && changes.addNewField.currentValue) {
      const newRecordObj = changes.addNewField.currentValue;
      if (newRecordObj.name == 'Field') {
        this.showAddOppData();
      }
    }
  }

  ngOnInit(): void {
    this.loadAccountTypes();
    this.loadOpportunitySources();
    this.getClosedReasons('LostReason');
    this.getClosedReasons('WonReason');
    this.getActiveInactiveReason('ActivatedReason');
    this.getActiveInactiveReason('InactivatedReason');
  }

  loadAccountTypes() {
    this.appMainService.isShowSpinner('loadRatings')
    this.ratingSubscription$ = this.fieldService.getAllOppRatings().subscribe(ratings => {
      this.appMainService.isHideSpinner('loadRatings')
      this.ratings = ratings;
    }, err => {
      this.appMainService.isHideSpinner('loadRatings')
    });
  }

  loadOpportunitySources() {
    this.appMainService.isShowSpinner('loadSources')
    this.fieldService.getAllOpportunitySource(this.app.user.organizationId).subscribe(sources => {
      this.oppSources = sources;
      this.appMainService.isHideSpinner('loadSources')
    }, (err) => {
      this.appMainService.isHideSpinner('loadSources')
    });
  }

  getClosedReasons(groupName) {
    this.appMainService.isShowSpinner('getClosedReasons')
    this.opportunityService.getActiveInactiveDataByName(groupName).subscribe(
      // data => {
      //   this.appMainService.isHideSpinner('getClosedReasons');
      //   if (groupId == 7) {
      //     this.closeLostReasons = closedReason ? closedReason : [];
      //   } else {
      //     this.closeWonReasons = closedReason ? closedReason : [];
      //   }
        dataName => {
          this.appMainService.isHideSpinner('getClosedReasons');
          dataName &&
              this.opportunityService.getActiveInactiveReasons(dataName.id).subscribe(
                  res => {
                      if (groupName == 'LostReason') {
                          this.lostId = dataName.id;
                          this.closeLostReasons = res ? res : [];
                          this.closeLostReasons.sort((a, b) => a.name.localeCompare(b.name));
                      } else {
                          this.wonId = dataName.id;
                          this.closeWonReasons = res ? res : [];
                          this.closeWonReasons.sort((a, b) => a.name.localeCompare(b.name));
                      }
    
                  },
                  () => {
                      this.appMainService.isHideSpinner('getClosedReasons');
                  });
      },
      err => {
        this.appMainService.isHideSpinner('getClosedReasons');
      })

  }

  showAddOppData() {
    this.displayAddOppData = true;

    this.addEditOppHeader = "Add Field Data";
    this.invalidData = false;

    this.oppDataTemp = {
      "id": 0,
      "createdSource": "",
      "updatedSource": "",
      "createdBy": this.app.user.userId,
      "updatedBy": 0,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "name": "",
      "description": "",
      "statusId": 0,
      "isActive": false,
      "isDefault": false,
      "organizationId": this.app.user.organizationId,
    }

  }

  showEditOppData(c, s) {
    this.oppDataTemp = JSON.parse(JSON.stringify(c));

    if (s.id == 4 || s.id == 5) {
        this.oppDataTemp.isActive = this.oppDataTemp.statusId == 1 ? true : false;
    }

    this.oppTypeId = s.id;
    this.addEditOppHeader = "Edit Field Data";
    this.displayAddOppData = true;
    this.showValidation = false;
    this.selectedOppDataType = this.oppDataTypes[s.id];
  }

  // getOpportunityDataType(): void {
  //   if (this.selectedOppDataType.code == "ActivatedReason" || this.selectedOppDataType.code == "InactivatedReason"){
  //     this.oppDataTemp = {
  //       "id": 0,
  //       "createdSource": this.app.userIP,
  //       "updatedSource": this.app.userIP,
  //       createdBy: this.app.user.userId,
  //       "updatedBy": this.app.user.organizationId,
  //       "createdDate": new Date().toISOString(),
  //       "updatedDate": new Date().toISOString(),
  //       "name": "",
  //       "description": "",
  //       "statusId": 1,
  //       "isActive": true,
  //       "isDefault": false
  //   }
  //   }
  // }

  cancelOppDataAdd(form: NgForm) {
    form.resetForm()
  }

  saveOppDataAdd() {

    //this.isOppDataDisabled = true;
    this.oppDataTemp.createdSource = this.app.userIP;
    this.oppDataTemp.createdBy = this.app.user.userId;
    this.oppDataTemp.statusId = 1;
    this.oppDataTemp.createdDate = new Date().toISOString();
    this.oppDataTemp.organizationId = this.app.user.organizationId

    if (this.addEditOppHeader == "Add Field Data") {
      if (!this.selectedOppDataType || !this.oppDataTemp.name || this.oppDataTemp.name.trim() === '') {
        this.showValidation = true;
        return;
      }

      this.showValidation = false;
      if (this.selectedOppDataType.code == 'opp source') {
        let lowerOppNames = [];
        for (let s of this.oppSources) {
          lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }

        if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
          this.invalidData = true;
          this.isOppDataDisabled = false;
        } else {
          this.service.addOppSource(this.oppDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Source Field Data Added Successfully...' });
            this.service.getAllOppSource(this.app.user.organizationId).then(sources => {
              this.oppSources = sources;
            });
            this.isOppDataDisabled = false;
            this.displayAddOppData = false;
          });

        }
      } else if (this.selectedOppDataType.code == 'quality') {
        let lowerOppNames = [];
        for (let s of this.ratings) {
          lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }
        if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
          this.invalidData = true;
          this.isOppDataDisabled = false;
        } else {
          this.service.addRating(this.oppDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quality Field Data Added Successfully...' });
            this.service.getAllOppRatings().then(ratings => {
              this.ratings = ratings;
            });
            this.isOppDataDisabled = false;
            this.displayAddOppData = false;
          });

        }
      } else if (this.selectedOppDataType.code == 'closewon' || this.selectedOppDataType.code == 'closelost') {
        this.addCloseReason();
      } else if (this.selectedOppDataType.code == 'ActivatedReason' || this.selectedOppDataType.code == 'InactivatedReason') {
        this.addActiveInactiveReason();
      }
    } else if (this.addEditOppHeader == "Edit Field Data") {

      if (!this.selectedOppDataType || !this.oppDataTemp.name || this.oppDataTemp.name.trim() === '') {
        this.showValidation = true;
        return;
      }

      this.showValidation = false;

      if (this.oppTypeId == 0) {
        let lowerOppNames = [];
        const index = this.oppSources.findIndex(s => s.id == this.oppDataTemp.id);
        this.oppSources.splice(index, 1);


        for (let s of this.oppSources) {
          lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }


        if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {

          this.invalidData = true;
          this.isOppDataDisabled = false;
        } else {
          this.service.EditOppSource(this.oppDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Source Field Data Updated Successfully...' });
            this.service.getAllOppSource(this.app.user.organizationId).then(sources => {
              this.oppSources = sources;
            });
            this.isOppDataDisabled = false;
            this.displayAddOppData = false;
          });

        }
      } else if (this.oppTypeId == 1) {
        let lowerOppNames = [];
        const index = this.ratings.findIndex(s => s.id == this.oppDataTemp.id);
        this.ratings.splice(index, 1);

        for (let s of this.ratings) {
          lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }


        if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
          this.invalidData = true;
          this.isOppDataDisabled = false;
        } else {
          this.service.EditRating(this.oppDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quality Field Data Updated Successfully...' });
            this.service.getAllOppRatings().then(ratings => {
              this.ratings = ratings;
            });
            this.isOppDataDisabled = false;
            this.displayAddOppData = false;
          });

        }
      } else if (this.oppTypeId == 2 || this.oppTypeId == 3) {
        this.updateCloseReason();
      }else if (this.oppTypeId == 4 || this.oppTypeId == 5) {
        this.updateActiveInactiveReason();
      }
    }

    //form.resetForm();
  }

  addCloseReason() {
    let lowerOppNames = [];
    for (let s of (this.selectedOppDataType.code == 'closelost' ? this.closeLostReasons : this.closeWonReasons)) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
      this.isOppDataDisabled = false;
    } else {
      let addData = { ...this.oppDataTemp, groupId: (this.selectedOppDataType.code == 'closelost' ? this.lostId : this.wonId) };
      this.opportunityService.addClosedReasons(addData).subscribe(stages => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Close Reason Data Added Successfully...' });
        this.getClosedReasons((this.selectedOppDataType.code == 'closelost' ? 'LostReason' : 'WonReason'));
        this.isOppDataDisabled = false;
        this.displayAddOppData = false;
      },
        err => {
          this.isOppDataDisabled = false;
          this.displayAddOppData = false;
        });
    }
  }

  updateCloseReason() {
    let lowerOppNames = [];

    const index = this.oppTypeId == 2 ? this.closeWonReasons.findIndex(s => s.id == this.oppDataTemp.id) :
      this.closeLostReasons.findIndex(s => s.id == this.oppDataTemp.id);

    if (this.oppTypeId == 2) {
      this.closeWonReasons.splice(index, 1);
    } else {
      this.closeLostReasons.splice(index, 1);
    }

    for (let s of (this.oppTypeId == 2 ? this.closeWonReasons : this.closeLostReasons)) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }

    if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
      this.isOppDataDisabled = false;
    } else {
      let addData = { ...this.oppDataTemp, groupId: this.oppTypeId == 2 ? this.wonId : this.lostId };
      this.opportunityService.updateClosedReasons(addData).subscribe(stages => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Close Reason Data Updated Successfully...' });
        this.getClosedReasons(this.oppTypeId == 2 ? 'WonReason' : 'LostReason');
        this.isOppDataDisabled = false;
        this.displayAddOppData = false;
      }, err => {
        this.isOppDataDisabled = false;
        this.displayAddOppData = false;
      });

    }
  }

  delOppSource(c) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Opportunity Source?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteOppSource(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Source Field Data Deleted Successfully...' });
          this.service.getAllOppSource(this.app.user.organizationId).then(sources => {
            this.oppSources = sources;
          });
        }).catch((error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error?.Message });
        });
      },
      reject: () => {
      }
    });
  }

  delQuality(c) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Quality?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteRating(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quality Deleted Successfully...' });
          this.service.getAllOppRatings().then(ratings => {
            this.ratings = ratings;
          });
        }).catch((error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error?.Message });
        });
      },
      reject: () => {
      }
    });
  }

  deleteCloseReason(c, s) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Reason?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.opportunityService.deleteClosedReasons(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Deleted Successfully...' });
          if (s.id == 2) {
            this.getClosedReasons('WonReason');
          } else {
            this.getClosedReasons('LostReason');
          }
        },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
          });
      },
      reject: () => {
      }
    });
  }


  addActiveInactiveReason() {
    let lowerOppNames = [];

    for (let s of (this.selectedOppDataType.code == 'ActivatedReason' ? this.activeReason : this.inactiveReason)) {
        lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
    } else {
        let addData = {
            ...this.oppDataTemp,
            groupId: (this.selectedOppDataType.code == 'ActivatedReason' ? this.activeId : this.inactiveId)
        };
        this.appMainService.isShowSpinner('addActiveInActiveReason');
        this.opportunityService.addActiveInactiveReason(addData).subscribe(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Added Successfully...' });
            this.getActiveInactiveReason((this.selectedOppDataType.code));
            this.displayAddOppData = false;
            this.invalidData = false;
            this.appMainService.isHideSpinner('addActiveInActiveReason');
        }, () => {
            this.displayAddOppData = false;
            this.invalidData = false;
        });
    }
  }

  updateActiveInactiveReason() {
    let lowerOppNames = [];

    const index = this.oppTypeId == 4 ? this.activeReason.findIndex(s => s.id == this.oppDataTemp.id) :
        this.inactiveReason.findIndex(s => s.id == this.oppDataTemp.id);

    if (this.oppTypeId == 4) {
        this.activeReason.splice(index, 1);
    } else {
        this.inactiveReason.splice(index, 1);
    }

    for (let s of (this.oppTypeId == 4 ? this.activeReason : this.inactiveReason)) {
        lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }

    if (lowerOppNames.indexOf(this.oppDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
    } else {
        this.oppDataTemp.statusId = this.oppDataTemp.isActive ? 1 : 2;
        let addData = { ...this.oppDataTemp, groupId: this.oppTypeId == 4 ? this.activeId : this.inactiveId };
        this.appMainService.isShowSpinner('updateActiveInActiveReason');
        this.opportunityService.updateActiveInactiveReason(addData).subscribe(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Updated Successfully...' });
            this.getActiveInactiveReason(this.oppTypeId == 4 ? 'ActivatedReason' : 'InactivatedReason');
            this.displayAddOppData = false;
            this.invalidData = false;
            this.appMainService.isHideSpinner('updateActiveInActiveReason');
        }, () => {
            this.displayAddOppData = false;
            this.invalidData = false;
        });
    }
}

  getActiveInactiveReason(groupName: string): void{
    this.appMainService.isShowSpinner('getActiveInActiveReasons');

    this.opportunityService.getActiveInactiveDataByName(groupName).subscribe(
        dataName => {
            this.appMainService.isHideSpinner('getActiveInActiveReasons');
            dataName &&
                this.opportunityService.getActiveInactiveReasons(dataName.id).subscribe(
                    res => {
                        if (groupName == 'ActivatedReason') {
                            this.activeId = dataName.id;
                            this.activeReason = res ? res : [];
                            this.activeReason.sort((a, b) => a.name.localeCompare(b.name));
                        } else {
                            this.inactiveId = dataName.id;
                            this.inactiveReason = res ? res : [];
                            this.inactiveReason.sort((a, b) => a.name.localeCompare(b.name));
                        }
                    },
                    () => {
                        this.appMainService.isHideSpinner('getActiveInActiveReasons');
                    });
        },
        () => {
            this.appMainService.isHideSpinner('getActiveInActiveReasons');
        })
  }

  _updateDefaultData(updateData) {
    this.appMainService.isShowSpinner('updateChannel')
    this.opportunityService.updateActiveInactiveReason(updateData).subscribe(stages => {
        this.appMainService.isHideSpinner('updateChannel')
    }, () => {
        this.appMainService.isHideSpinner('updateChannel')
    });
 }

  makeActiveInactiveDefault(data) {
    let updateData = data;
    if (updateData.groupId == this.activeId) {
        this.activeReason.forEach(element => {
            if (element.id != updateData.id) {
                element.isDefault = false;
                this._updateDefaultData(element);
            }
        });
    } else {
        this.inactiveReason.forEach(element => {
            if (element.id != updateData.id) {
                element.isDefault = false;
                this._updateDefaultData(element);
            }
        });
    }

    this.appMainService.isShowSpinner('updateChannel');
    this.opportunityService.updateActiveInactiveReason(updateData).subscribe(() => {
        this.appMainService.isHideSpinner('updateChannel');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
        this.getActiveInactiveReason(updateData.groupId == this.activeId ? 'ActivatedReason' : 'InactivatedReason');
    }, () => {
        this.appMainService.isHideSpinner('updateChannel');
    });
  }

  deleteActiveInactiveReason(c, s) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Reason?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.opportunityService.deleteActiveInactiveReason(c.id).subscribe(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Deleted Successfully...' });
                    if (s.id == 4) {
                        this.getActiveInactiveReason('ActivatedReason');
                    } else {
                        this.getActiveInactiveReason('InactivatedReason');
                    }
                }, () => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
                });
            }
        });
  }

  cancleAddEditFieldData(){
    this.invalidData = false;
  }

  ngOnDestroy() {
    this.ratingSubscription$.unsubscribe();
  }

}
